import styles from './styles.module.scss';

export default function Pergunta({ p, deletarMembro,editar }) {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>{p.title}</h3>
      <ul className={styles.options}>
        {[p.q1, p.q2, p.q3, p.q4, p.q5].map((opt, i) => (
          <li key={i} className={`${styles.option} ${p.correct == (i+1)? styles.correct : ''}`}>
            {opt}
          </li>
        ))}
      </ul>
      {p.image && (
        <img  src={p.image} alt="Imagem da publicação" className={styles.image} />
      )}
      <button   type="button" 
 onClick={() => deletarMembro(p.id)} className={styles.delete}>
        Deletar
      </button>
      <button   type="button" 
 onClick={() => editar(p)} className={`${styles.editar}`}>
        Editar
      </button>
    </div>
  );
}
